import React, { FC, useState } from 'react';
import { ButtonProps, IconButton, Theme, styled } from '@material-ui/core';
import theme from '../../../config/theme';
import { Tooltip } from './Tooltip/index';
import DMToolTip from './Tooltip/DMToolTip';
import { FontAwesomeSpriteIcon } from './FontAwesomeLocal';
import { SpriteIcon } from 'src/config/api/models/FontAwesome';

const StyledIconButton = styled(IconButton)<Theme, { disabled: boolean }>(
  ({ theme, disabled }) => ({
    borderRadius: theme.config.defaultBorderRadius,
    padding: theme.spacing(1),
    opacity: disabled ? 0.5 : 1,
  })
);

type Props = ButtonProps & {
  icon: SpriteIcon;
  tooltip?: string | undefined;
  blocked?: boolean;
  blockedMessage?: any;
  visible?: boolean;
  primary?: boolean;
  disabled?: boolean;
  btSize?: 'sm' | 'md' | 'lg';
  onButtonClick?: () => void;
};

const AugmentationButton: FC<Props> = ({
  icon,
  id,
  className,
  btSize = 'lg',
  tooltip = undefined,
  visible = true,
  blocked = false,
  disabled = false,
  blockedMessage = '',
  primary = false,
  onButtonClick = () => {},
}) => {
  const [blockedTooltipOpened, setBlockedTooltipOpened] = useState(false);
  const handleCloseBlockedTooltip = () => {
    setBlockedTooltipOpened(false);
  };

  const handleOpenBlockedTooltip = () => {
    setBlockedTooltipOpened(true);
  };

  if (!visible) return <></>;

  const btn = (
    <StyledIconButton
      // TODO - check with FC why disabled prop is not being passed to MUI iconbutton automatically
      disabled={disabled}
      id={id}
      className={className}
      onClick={
        blocked
          ? () => {
              setBlockedTooltipOpened(true);
            }
          : onButtonClick
      }
    >
      <FontAwesomeSpriteIcon
        color={primary ? theme.palette.primary.main : theme.palette.secondary.main}
        icon={icon}
        iconSize={btSize}
      />
    </StyledIconButton>
  );

  return blocked ? (
    <DMToolTip
      controlled
      clickAwayActive
      opened={blockedTooltipOpened}
      onClose={handleCloseBlockedTooltip}
      onOpen={handleOpenBlockedTooltip}
      condition={true}
      title={tooltip}
      message={blockedMessage}
      placement="bottom-start"
    >
      {btn}
    </DMToolTip>
  ) : tooltip ? (
    <Tooltip title={tooltip} placement="left">
      {btn}
    </Tooltip>
  ) : (
    btn
  );
};

export default AugmentationButton;
